module.exports = require("core-js/library/fn/number/min-safe-integer");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/number/min-safe-integer.js
// module id = 677
// module chunks = 0